import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import SiteNav from '@/components/generals/site-nav'
import SiteFooter from '@/components/generals/site-footer'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col bg-ink'>
            <a
                href='#main'
                className='sr-only z-[60] rounded-lg bg-ember px-4 py-2 text-sm font-medium text-ink focus:not-sr-only focus:fixed focus:left-4 focus:top-4'
            >
                Skip to content
            </a>

            <SiteNav />

            <main id='main' className='flex-1'>
                {children}
            </main>

            <SiteFooter />
        </div>
    )
}
